import { compose, lifecycle, withHandlers, withPropsOnChange, withState } from 'recompose';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  getActiveDay,
  getActiveDayTimes,
  getActiveTime,
  getActiveTimeBarber,
  getNoTimesAvailable,
} from '../../times/selectors';
import {
  getAppointmentId,
  getAppointmentTime,
  isAppointmentPaid,
} from '../selectors';
import AvailableTimeRangeProvider from '../../hoc/AvailableTimeRangeProvider';
import { reschedule } from '../actions';
import config from '../../../config';
import WithTimezone from '../../hoc/WithTimezone';
import { clearBarberAvailability, setActiveDay, setActiveTime, setActiveTimeBarber } from '../../times/actions';
import PickTime from '../components/PickTime';
import { getBarberId } from '../../barbers/selectors';
import WithFetchBarbers from '../../hoc/WithFetchBarbers';
import { renderTurnstileChallenge, wait } from '../../utils/helpers';
import { getFlag } from '../../../flags';

const PickTimeContainer = compose(
  WithTimezone,
  WithFetchBarbers,
  connect(
    (state, ownProps) => {
      const noTimesAvailable = getNoTimesAvailable(state);

      return {
        noTimesAvailable,
        appointmentId: getAppointmentId(state),
        appointmentTime: getAppointmentTime(state),
        activeDay: getActiveDay(state),
        selectedTime: !noTimesAvailable && getActiveTime(state),
        times: getActiveDayTimes(state, ownProps.timezone),
        selectedBarberId: getBarberId(state, getActiveTimeBarber(state)),
        isAppointmentPaid: isAppointmentPaid(state),
      };
    },
    {
      clearBarberAvailability,
      setActiveDay,
      setActiveTime,
      reschedule,
      setActiveTimeBarber,
    },
  ),
  withState('isTurnstileChallengeVisible', 'setTurnstileChallengeVisibility', false),
  AvailableTimeRangeProvider('activeDay'),
  withHandlers({
    setTime: props => ({ time, barberRoute = '' }) => () => {
      props.setActiveTime(moment(time).format(config.timeSlugFormat));
      return props.setActiveTimeBarber(barberRoute);
    },
    rescheduleAndAskPromo: props => async () => {
      const isBotProtectionOn = await getFlag('check-if-human');
      if (props.isAppointmentPaid || !isBotProtectionOn) {
        return props.reschedule(
          props.appointmentId,
          moment(props.selectedTime, config.timeSlugFormat).toJSON(),
          props.selectedBarberId,
          'ask', // api returns an error in case a promo code is not valid for selected date
        );
      }

      props.setTurnstileChallengeVisibility(true);

      await wait(10); // let the container appear
      const { success, token } = await renderTurnstileChallenge('#turnstile');

      if (!success) {
        await wait(3000); // let users contemplate their browsing history for a while
        props.setTurnstileChallengeVisibility(false);
        return null;
      }

      await wait(1000); // pending-to-success animation
      props.setTurnstileChallengeVisibility(false);

      return props.reschedule(
        props.appointmentId,
        moment(props.selectedTime, config.timeSlugFormat).toJSON(),
        props.selectedBarberId,
        'ask', // api returns an error in case a promo code is not valid for selected date
        token,
      );
    },
    rescheduleAndRemovePromo: props => async () => {
      const isBotProtectionOn = await getFlag('check-if-human');
      if (props.isAppointmentPaid || !isBotProtectionOn) {
        return props.reschedule(
          props.appointmentId,
          moment(props.selectedTime, config.timeSlugFormat).toJSON(),
          props.selectedBarberId,
          'yes', // api removes promo code in case it's not valid for selected date
        );
      }

      props.setTurnstileChallengeVisibility(true);

      await wait(10); // let the container appear
      const { success, token } = await renderTurnstileChallenge('#turnstile');

      if (!success) {
        await wait(3000); // let users contemplate their browsing history for a while
        props.setTurnstileChallengeVisibility(false);
        return null;
      }

      await wait(1000); // pending-to-success animation
      props.setTurnstileChallengeVisibility(false);

      return props.reschedule(
        props.appointmentId,
        moment(props.selectedTime, config.timeSlugFormat).toJSON(),
        props.selectedBarberId,
        'yes', // api removes promo code in case it's not valid for selected date
        token,
      );
    },
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.setActiveTime('');
    },
  }),
  withPropsOnChange(['appointmentTime'], (props) => {
    props.setActiveTime(moment(props.appointmentTime).format(config.timeSlugFormat));
  }),
)(PickTime);

export default PickTimeContainer;



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PickTime.js